import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/Digitize.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Houston's Tech Hub: Enabling Digital Transformation through
              Software Development in Houston
            </h2>
            <p>
              Houston is rapidly evolving into a dynamic tech hub, playing a
              pivotal role in driving digital transformation for businesses
              across various industries.
            </p>
            <p>
              Through innovative software development, this vibrant city is
              enabling companies to embrace the digital era and seize new
              opportunities. Our tech experts in Houston are at the forefront of
              this transformation, crafting cutting-edge software solutions
              tailored to your specific needs. We empower businesses to
              streamline operations, enhance customer experiences, and achieve
              unprecedented growth.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#F47A1F",
                border: "1px solid #F47A1F",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
